import { render, staticRenderFns } from "./tableOrder.vue?vue&type=template&id=42bb14d0&"
import script from "./tableOrder.vue?vue&type=script&lang=js&"
export * from "./tableOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports